import React from 'react';
import { render } from 'react-dom';
import { App } from './pages/App';
// eslint-disable-next-line
import 'swiper/css/bundle';

render(<App />, document.getElementById('root'));
